/* ANIMORA — interactions légères : reveal au scroll, drawer mobile, collection AJAX.
   Sans dépendance. Respecte prefers-reduced-motion (géré en CSS). */
(function () {
  'use strict';

  /* Reveal progressif des éléments .am-reveal */
  function initReveal() {
    var els = document.querySelectorAll('.am-reveal:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Drawer mobile (header) */
  function initDrawer() {
    var drawer = document.querySelector('[data-am-drawer]');
    if (!drawer) return;
    var openBtns = document.querySelectorAll('[data-am-drawer-open]');
    var closeEls = drawer.querySelectorAll('[data-am-drawer-close]');
    var firstLink = drawer.querySelector('a, button');

    function open() {
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      if (firstLink) firstLink.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
      openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    }
    openBtns.forEach(function (b) { b.addEventListener('click', open); });
    closeEls.forEach(function (c) { c.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  }

  function initNavScroll() {
    document.querySelectorAll('.am-nav__list').forEach(function (nav) {
      nav.scrollLeft = 0;
    });
  }

  function initFilters() {
    document.querySelectorAll('[data-am-filters]').forEach(function (form) {
      if (form.dataset.amFiltersReady) return;
      form.dataset.amFiltersReady = 'true';
      var timer;

      // Normalise les prix saisis/pré-remplis à la française (« 12,50 ») en décimal Shopify (« 12.50 »)
      function normalizePrices() {
        form.querySelectorAll('.am-price-range input').forEach(function (input) {
          if (input.value) input.value = input.value.replace(/\s/g, '').replace(',', '.');
        });
      }

      // Filet de sécurité : normalise sur toute soumission (bouton, Entrée, requestSubmit)
      form.addEventListener('submit', normalizePrices);

      function submitSoon(delay) {
        window.clearTimeout(timer);
        timer = window.setTimeout(function () {
          normalizePrices();
          if (form.requestSubmit) form.requestSubmit();
          else form.submit();
        }, delay || 0);
      }

      form.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
        input.addEventListener('change', function () { submitSoon(0); });
      });

      form.querySelectorAll('.am-price-range input').forEach(function (input) {
        input.addEventListener('keydown', function (event) {
          if (event.key === 'Enter') {
            event.preventDefault();
            submitSoon(0);
          }
        });
        input.addEventListener('change', function () { submitSoon(250); });
      });
    });
  }

  /* Collection en AJAX : chips de catégorie, filtres, tri et pagination
     se chargent sans recharger toute la page ni remonter en haut.
     Amélioration progressive : si quoi que ce soit échoue, on retombe
     sur la navigation classique (window.location). */
  function initCollectionAjax() {
    var container = document.querySelector('[data-am-collection]');
    if (!container || container.dataset.amAjaxReady) return;
    container.dataset.amAjaxReady = 'true';
    var sectionId = container.dataset.sectionId;
    if (!sectionId || !window.fetch || !window.DOMParser || !window.history || !history.pushState) return;

    function withSection(url) {
      return url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sectionId);
    }

    function load(url, push) {
      var live = document.querySelector('[data-am-collection]');
      if (live) live.classList.add('am-loading');
      fetch(withSection(url), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { if (!r.ok) throw new Error('http'); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-am-collection]');
          var liveNow = document.querySelector('[data-am-collection]');
          if (!fresh || !liveNow) { window.location.href = url; return; }
          liveNow.innerHTML = fresh.innerHTML;
          liveNow.classList.remove('am-loading');
          // Contenu injecté = directement visible (pas d'attente d'animation)
          liveNow.querySelectorAll('.am-reveal').forEach(function (el) { el.classList.add('is-in'); });
          initFilters();
          if (push) history.pushState({ amCollection: true }, '', url);
        })
        .catch(function () { window.location.href = url; });
    }

    // Liens internes : chips de catégorie + pagination
    container.addEventListener('click', function (e) {
      var a = e.target.closest('a');
      if (!a || !container.contains(a)) return;
      var isChip = a.classList.contains('am-chip');
      var isPager = a.closest('.am-pagination');
      if (!isChip && !isPager) return;
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#' || a.target === '_blank') return;
      e.preventDefault();
      load(href, true);
    });

    // Formulaires : filtres + tri
    container.addEventListener('submit', function (e) {
      var form = e.target.closest('form');
      if (!form || !container.contains(form)) return;
      if (!form.closest('.am-filters') && !form.classList.contains('am-collection-sort')) return;
      e.preventDefault();
      form.querySelectorAll('.am-price-range input').forEach(function (i) {
        if (i.value) i.value = i.value.replace(/\s/g, '').replace(',', '.');
      });
      var params = new URLSearchParams();
      new FormData(form).forEach(function (v, k) { if (v !== '') params.append(k, v); });
      var action = form.getAttribute('action') || window.location.pathname;
      var qs = params.toString();
      load(qs ? action + '?' + qs : action, true);
    });

    window.addEventListener('popstate', function () {
      load(window.location.pathname + window.location.search, false);
    });
  }

  function init() { initReveal(); initDrawer(); initNavScroll(); initFilters(); initCollectionAjax(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init dans l'éditeur de thème Shopify (sections rechargées dynamiquement)
  document.addEventListener('shopify:section:load', init);
})();
